<template lang="pug">
  div
    // begin #header
    #header.header.navbar-default
      // begin navbar-header
      .navbar-header
        button.navbar-toggle(type='button', v-on:click='toggleMobileSidebar', v-if='!pageOptions.pageWithoutSidebar')
          span.icon-bar
          span.icon-bar
          span.icon-bar
        router-link.navbar-brand.desktop(to='/overview')
          b {{ $helpers.getUplineName($store.getters.accountType).toUpperCase() }}
        ul.navbar-nav.navbar-right.w-100(v-if='!pageOptions.pageWithoutSidebar')
          router-link.navbar-brand.mobile(to='/overview' style="margin-right:0px;padding:0px;")
            b {{ $helpers.getUplineName($store.getters.accountType).toUpperCase() }}
          b-nav-item.d-md-none.d-lg-none
            i.fa.fa-envelope(@click="openPm")
            span.label(v-if="unreadCount") {{ unreadCount }}
          b-nav-item-dropdown.navbar-user.d-md-none.d-lg-none(menu-class='dropdown-menu-right', no-caret='')
            template(slot='button-content')
              .d-flex.align-items-center
                .image.image-icon.bg-black.text-grey-darker
                  v-gravatar(:email="$store.getters.loginID")
                //- span.d-none.mr-1 {{ $store.getters.profileID }}
                //- span(v-if="$store.getters.profileID != $store.getters.loginID") ({{ $store.getters.loginID }})
                b.caret
            b-dropdown-item {{ $store.getters.profileID.toUpperCase() }}
            b-dropdown-divider
            b-dropdown-item(@click="go('/settings')") {{ $t("ui.settings") }}
            b-dropdown-item(@click="go('/messages')") {{ $t("ui.messages") }}
            b-dropdown-divider
            b-dropdown-item(href='/logout') {{ $t("ui.logout") }}
          b-nav-item-dropdown.d-md-none.d-lg-none(menu-class='navbar-language', no-caret='')
            template(slot='button-content')
              template(v-if="$store.getters.language == 'en'")
                span.flag-icon.flag-icon-us.mr-1(title='us')
                //- span.name.mr-1 {{ $t("language.english").toUpperCase() }}
              template(v-if="$store.getters.language == 'zh'")
                span.flag-icon.flag-icon-cn.mr-1(title='zh')
                //- span.name.mr-1 {{ $t("language.simplified_chinese").toUpperCase() }}
              template(v-if="$store.getters.language == 'vi'")
                span.flag-icon.flag-icon-vn.mr-1(title='vi')
                //- span.name.mr-1 {{ $t("language.vietnamese").toUpperCase() }}
              template(v-if="$store.getters.language == 'th'")
                span.flag-icon.flag-icon-th.mr-1(title='th')
                //- span.name.mr-1 {{ $t("language.thai").toUpperCase() }}
              template(v-if="$store.getters.language == 'jp'")
                span.flag-icon.flag-icon-jp.mr-1(title='jp')
              template(v-if="$store.getters.language == 'kh'")
                span.flag-icon.flag-icon-kh.mr-1(title='kh')
              b.caret
            b-dropdown-item(@click="setLanguage('en')")
              span.flag-icon.flag-icon-us.mr-1(title='us')
              span.text-dark {{ $t("language.english").toUpperCase() }}
            b-dropdown-item(@click="setLanguage('zh')")
              span.flag-icon.flag-icon-cn.mr-1(title='zh')
              span.text-dark {{ $t("language.simplified_chinese").toUpperCase() }}
            b-dropdown-item(@click="setLanguage('vi')")
              span.flag-icon.flag-icon-vn.mr-1(title='vi')
              span.text-dark {{ $t("language.vietnamese").toUpperCase() }}
            b-dropdown-item(@click="setLanguage('th')")
              span.flag-icon.flag-icon-th.mr-1(title='th')
              span.text-dark {{ $t("language.thai").toUpperCase() }}
            b-dropdown-item(@click="setLanguage('jp')")
              span.flag-icon.flag-icon-jp.mr-1(title='jp')
              span.text-dark {{ $t("language.japanese").toUpperCase() }}
            b-dropdown-item(@click="setLanguage('kh')")
              span.flag-icon.flag-icon-kh.mr-1(title='kh')
              span.text-dark {{ $t("language.combodia").toUpperCase() }}
        button.navbar-toggle.pt-0.pb-0.mr-0.collapsed(type='button', v-on:click='toggleMobileTopMenu', v-if='pageOptions.pageWithTopMenu && !pageOptions.pageWithoutSidebar')
          span.fa-stack.fa-lg.text-inverse
            i.far.fa-square.fa-stack-2x
            i.fa.fa-cog.fa-stack-1x
        button.navbar-toggle(type='button', v-on:click='toggleMobileTopMenu', v-if='pageOptions.pageWithTopMenu && pageOptions.pageWithoutSidebar')
          span.icon-bar
          span.icon-bar
          span.icon-bar
        button.navbar-toggle.p-0.m-r-0(type='button', v-on:click='toggleMobileMegaMenu', v-if='pageOptions.pageWithMegaMenu')
          span.fa-stack.fa-lg.text-inverse.m-t-2
            i.far.fa-square.fa-stack-2x
            i.fa.fa-cog.fa-stack-1x
      // end navbar-header
      header-mega-menu(v-if='pageOptions.pageWithMegaMenu')
      // begin header-nav
      ul.navbar-nav.navbar-right.header-main-nav
        b-nav-item.header-home-btn
          i.fa.fa-home(@click="$router.push('/overview').catch(err => {})")
        b-nav-item.flex-grow-1.header-marquee-slot
          Marquee
        b-nav-item.d-none.d-md-inline(style="min-width:170px;")
          span {{ currentTime }}
        b-nav-item.d-none.d-md-inline
          i.fa.fa-envelope(@click="openPm")
          span.label(v-if="unreadCount") {{ unreadCount }}
        b-nav-item-dropdown.d-none.d-md-inline(menu-class='navbar-language', no-caret='')
          template(slot='button-content')
            template(v-if="$store.getters.language == 'en'")
              span.flag-icon.flag-icon-us.mr-1(title='us')
              span.name.mr-1 {{ $t("language.english").toUpperCase() }}
            template(v-if="$store.getters.language == 'zh'")
              span.flag-icon.flag-icon-cn.mr-1(title='zh')
              span.name.mr-1 {{ $t("language.simplified_chinese").toUpperCase() }}
            template(v-if="$store.getters.language == 'vi'")
              span.flag-icon.flag-icon-vn.mr-1(title='vi')
              span.name.mr-1 {{ $t("language.vietnamese").toUpperCase() }}
            template(v-if="$store.getters.language == 'th'")
              span.flag-icon.flag-icon-th.mr-1(title='th')
              span.name.mr-1 {{ $t("language.thai").toUpperCase() }}
            template(v-if="$store.getters.language == 'jp'")
              span.flag-icon.flag-icon-jp.mr-1(title='jp')
              span.name.mr-1 {{ $t("language.japanese").toUpperCase() }}
            template(v-if="$store.getters.language == 'kh'")
              span.flag-icon.flag-icon-kh.mr-1(title='kh')
              span.name.mr-1 {{ $t("language.combodia").toUpperCase() }}
            b.caret
          b-dropdown-item(@click="setLanguage('en')")
            span.flag-icon.flag-icon-us.mr-1(title='us')
            span.text-dark {{ $t("language.english").toUpperCase() }}
          b-dropdown-item(@click="setLanguage('zh')")
            span.flag-icon.flag-icon-cn.mr-1(title='zh')
            span.text-dark {{ $t("language.simplified_chinese").toUpperCase() }}
          b-dropdown-item(@click="setLanguage('vi')")
            span.flag-icon.flag-icon-vn.mr-1(title='vi')
            span.text-dark {{ $t("language.vietnamese").toUpperCase() }}
          b-dropdown-item(@click="setLanguage('th')")
            span.flag-icon.flag-icon-th.mr-1(title='th')
            span.text-dark {{ $t("language.thai").toUpperCase() }}
          b-dropdown-item(@click="setLanguage('jp')")
            span.flag-icon.flag-icon-jp.mr-1(title='jp')
            span.text-dark {{ $t("language.japanese").toUpperCase() }}
          b-dropdown-item(@click="setLanguage('kh')")
            span.flag-icon.flag-icon-kh.mr-1(title='kh')
            span.text-dark {{ $t("language.combodia").toUpperCase() }}
        b-nav-item-dropdown.navbar-user.d-none.d-md-inline(menu-class='dropdown-menu-right', no-caret='')
          template(slot='button-content')
            .d-flex.align-items-center
              .image.image-icon.bg-black.text-grey-darker
                v-gravatar(:email="$store.getters.loginID")
              span.d-none.d-md-inline.mr-1 {{ $store.getters.profileID.toUpperCase() }}
              span(v-if="$store.getters.profileID != $store.getters.loginID") ({{ $store.getters.loginID.toUpperCase() }})
              b.caret
          b-dropdown-item(@click="go('/settings')") {{ $t("ui.settings") }}
          b-dropdown-item(@click="go('/messages')") {{ $t("ui.messages") }}
          b-dropdown-divider
          b-dropdown-item(href='/logout') {{ $t("ui.logout") }}
      // end header navigation right
      // end #header
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";
import HeaderMegaMenu from "./HeaderMegaMenu.vue";
import { setInterval } from "timers";
import Marquee from "@/components/settings/marquee.vue";

export default {
  name: "Header",
  components: {
    HeaderMegaMenu,
    Marquee
  },
  data() {
    return {
      pageOptions: PageOptions,
      currentTime: null,
      unreadCount: 0
    };
  },
  computed: {
    username() {
      return this.$store.getters.displayName || this.$store.getters.loginID;
    }
  },
  created: function() {
    this.currentTime = this.$moment().subtract(12, "hours").format("YYYY-MM-DD HH:mm:ss") + " " + this.$moment().format("A");
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.updateCurrentTime());
  },
  mounted() {
    this.getPersonalUnread();
  },
  methods: {
    go(e) {
      if (this.$router.currentRoute.path !== e) this.$router.push(e);
    },
    toggleMobileSidebar() {
      this.pageOptions.pageMobileSidebarToggled = !this.pageOptions.pageMobileSidebarToggled;
    },
    toggleMobileRightSidebar() {
      this.pageOptions.pageMobileRightSidebarToggled = !this.pageOptions.pageMobileRightSidebarToggled;
    },
    toggleMobileTopMenu() {
      this.pageOptions.pageMobileTopMenu = !this.pageOptions.pageMobileTopMenu;
    },
    toggleMobileMegaMenu() {
      this.pageOptions.pageMobileMegaMenu = !this.pageOptions.pageMobileMegaMenu;
    },
    toggleRightSidebar() {
      this.pageOptions.pageRightSidebarToggled = !this.pageOptions.pageRightSidebarToggled;
    },
    toggleRightSidebarCollapsed() {
      this.pageOptions.pageRightSidebarCollapsed = !this.pageOptionspageRightSidebarCollapsed;
    },
    updateCurrentTime: function() {
      this.currentTime = this.$moment().subtract(12, "hours").format("YYYY-MM-DD HH:mm:ss") + " " + this.$moment().format("A")
    },
    getPersonalUnread() {
      this.$store.dispatch("message/getPersonalUnread").then(res => {
        this.unreadCount = res.value[0].count_unread;
      });
    },
    openPm() {
      if (this.$router.currentRoute.path == "/messages") return;
      if (this.unreadCount) this.$router.push("/messages?redir=p");
      else this.$router.push("/messages");
      this.unreadCount = 0;
    },
    setLanguage(lang){
      this.$store.dispatch("layout/setLanguage", lang);
    }
  }
};
</script>

<style lang="scss" scoped>
.mail-button {
  margin: auto 0 auto auto;
  background: transparent;
  border: none;
  color: #00acac;
  position: relative;
  font-size: 16px;
  .badge {
    position: absolute;
    cursor: pointer;
    font-size: 12px;
    font-style: lighter;
    &:hover {
      background: darkred;
    }
  }
}
</style>